/**
 * Application Constants
 * Single source of truth for hardcoded values across the application
 */

// Subscription Plan IDs
export const FREEMIUM_PLAN_ID = '2c3cf15f-5e9d-4eca-8608-47c9c69b7857';
export const FREEMIUM_CREDIT_ALLOCATION = 30;

// Default Pinned Apps
export const DEFAULT_PINNED_APPS = {
  app_1: 'text-generator',
  app_2: 'research-generator',
  app_3: 'image-generator',
  app_4: 'video-generator'
} as const; 